export default function useGetSlicedNumber(
  targetNum: number,
  fromDigit: number,
  toDigit: number
): number {
  const numStr = targetNum.toString();
  numStr.slice(fromDigit, toDigit);
  return parseInt(numStr);
}
